module.exports = __webpack_public_path__ + "assets/img/65_525_2.83beaf1a.jpg";